<template>
    <div class="row justify-content-center">
        <div class="col-xl-8">
            <div class="editor editor--single-el">
                <div v-if="matchPost.content.rendered" v-html="matchPost.content.rendered"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                seoPosts: [],
                filterTaxIds: [],
                matchPost: {
                    content: {
                        rendered: ''
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                filterTrigger: 'filterTrigger',
            }),
            allFiltersSetFromUrl() {
                return this.$store.state.allFiltersSetFromUrl;
            },
            resetFiltersAll() {
                return this.$store.state.resetAllFilters;
            }
        },
        watch: {
            allFiltersSetFromUrl(value) {
                // console.log(value, 'allFiltersSetFromUrl');
                if (value === true) {
                    this.GetSeoText();
                }
            },
            resetFiltersAll(value) {
                if (value === true) {
                    this.matchPost.content.rendered = '';
                    this.GetSeoText();
                }
            },
            filterTrigger(value) {
                console.log('filterTrigger SEO')
                this.matchPost.content.rendered = '';
                this.GetSeoText();
            }
        },
        methods: {
            GetSeoText() {
                this.getFilterTaxIdsFromStore();

                let fetchUrl = window.location.origin;
                fetchUrl += '/wp-json/wp/v2/seo-tekst?per_page=89';

                return axios.get(fetchUrl)
                    .then(response => {
                        this.seoPosts = response.data;
                        this.findMatch();
                    })
                    .catch(e =>{

                    });
            },
            findMatch() {
                let _this = this;
                let seoPosts = this.seoPosts;
                // console.log(seoPosts, this.filterTaxIds)
                if (seoPosts.length > 0 && this.filterTaxIds.length) {
                    // Loop through all seo posts from post type
                    // console.log('Loping throug SEO posts');
                    seoPosts.forEach((seoPost, index) => {
                        let seoPostTaxIds = [];
                        let acfFields = seoPost.acf;
                        // Loop through all acf fields and add tax id to array if found (and not false)
                        for (const [key, value] of Object.entries(acfFields)) {
                            if (key.includes('seo') && value !== false) {
                                let taxId = parseInt(value);
                                seoPostTaxIds.push(taxId);
                            }
                        }

                        let proxiedFilterTaxIds = Object.assign({}, this.filterTaxIds);
                        let proxiedArray = Object.values(proxiedFilterTaxIds);

                        // console.log(proxiedArray, seoPostTaxIds);

                        if (proxiedArray.length === seoPostTaxIds.length) {

                            if (JSON.stringify(seoPostTaxIds.sort()) === JSON.stringify(proxiedArray.sort())) {
                                console.log('Match!!!', 'seoPostTaxIds',JSON.stringify(seoPostTaxIds.sort()), 'filterTaxIds', JSON.stringify(proxiedArray.sort()));
                                _this.matchPost.content.rendered = seoPost.content.rendered;
                            }
                            // console.log('Same length but no match');
                        }
                    });
                }
            },
            getFilterTaxIdsFromStore() {
                let filterTaxIds = [];

                let filtersFromStore = this.$store.state.Filters;
                filtersFromStore.forEach((filterItem, index) => {
                    if (filterItem.values.length > 0) {
                        filterItem.values.forEach((value, index) => {
                            filterTaxIds.push(value.id);
                        });
                    }
                });
                this.filterTaxIds = filterTaxIds;
            }
        }
    }
</script>